__turbopack_context__.v({
  "iconExpand": "IconExpand-module__QDVCPG__iconExpand",
});
